import React, { useState } from "react";
import Avatar from "../shared/Avatar";
import { useMiniChat } from "../../context/MiniChatContext";
import styles from "./ChatSidebar.module.css";

/* ── SVG Icons ──────────────────────────────────────────────────────── */
const IconChat = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" />
  </svg>
);

const IconChevronUp = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
  </svg>
);

const IconChevronDown = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
  </svg>
);

/**
 * Chat sidebar — fixed right edge panel showing online friends.
 *
 * @param {object}   props
 * @param {Array}    [props.onlineFriends] - Array of { username, first_name, last_name, photo }
 * @param {boolean}  [props.defaultOpen]   - Whether panel starts expanded
 */
export default function ChatSidebar({ onlineFriends = [], defaultOpen = true }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const { openMiniChat } = useMiniChat();

  return (
    <div className={`${styles.chatSidebar} ${isOpen ? styles.open : styles.collapsed}`.trim()}>
      {/* Header */}
      <button
        className={styles.header}
        onClick={() => setIsOpen((v) => !v)}
        aria-expanded={isOpen}
        aria-label={isOpen ? "Collapse chat" : "Expand chat"}
      >
        <span className={styles.headerTitle}>
          <IconChat />
          <span>Chat</span>
        </span>
        {isOpen ? <IconChevronDown /> : <IconChevronUp />}
      </button>

      {/* Body */}
      {isOpen && (
        <div className={styles.body}>
          {onlineFriends.length === 0 ? (
            <p className={styles.empty}>No friends online</p>
          ) : (
            <ul className={styles.list}>
              {onlineFriends.map((friend) => {
                const name =
                  `${friend.first_name || ""} ${friend.last_name || ""}`.trim() ||
                  friend.username ||
                  "User";
                return (
                  <li key={friend.username || friend._id || name} className={styles.item}>
                    <button
                      className={styles.friendLink}
                      onClick={() => openMiniChat(friend)}
                    >
                      <Avatar src={friend.photo} alt={name} size="sm" online />
                      <span className={styles.friendName}>{name}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
